import { Helmet } from 'react-helmet';
import Footer from "./components/footer"
import NavBar from "./components/navbar"
import Main from "./components/mainSection"
import './components/iphoneScreens.css';
import './App.css';

function App() {
  return (
    <div class="wrapper">
      {/* <Helmet>
        <title>Page Title - Your Site Name</title>
        <meta name="description" content="This is a description for the page." />
        <meta name="keywords" content="Shubox" />
        <meta name="author" content="Shubox" />
        <meta property="og:title" content="Register" />
        <meta property="og:description" content="This is a description for the page." />
        <meta property="og:image" content="path-to-your-social-image.jpg" />
        <meta property="og:url" content="https://your-website.com" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet> */}
      <NavBar />
      <Main />
      <div style={{ marginTop: 100 }}></div>
      <Footer />
    </div>
  );
}

export default App;
